import { useState } from "react";
import { Button, Form, Modal, Table } from "react-bootstrap";
import Select from "react-dropdown-select";
import Pagination from "react-js-pagination";
import ViewItemsPerPage from "../ViewItemsPerPage";
import PaginationWithControls from "../PaginationWithControls";

interface AppTagDetail {
  appTagId: number;
  tagId: number;
  tagName: string;
}

interface Tag {
  tagId: number;
  tagName: string;
}
interface ListTagDetailProps {
  tagsList: AppTagDetail[];
  resetFindOptions: () => void;
  findOptions: any;
  tagListForDropdown: Tag[];
  handleFind: (findOptions: any) => void;
  handelDelete: (appTagId: number, tagId: number) => void;
  totalItemCount: number;
  pageIndex: number;
  pageSize: number;
  onChangePageIndex: (pageNumber: number) => void;
  onChangePageSize: (pageSize: number) => void;
}

const ListTagDetail: React.FC<ListTagDetailProps> = ({
  tagsList,
  resetFindOptions,
  findOptions,
  tagListForDropdown,
  handleFind,
  handelDelete,
  totalItemCount,
  pageIndex,
  pageSize,
  onChangePageIndex,
  onChangePageSize,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [searchOptions, setSearchOptions] = useState(findOptions);
  const handleModalOpen = () => setShowModal(true);
  const handleModalClose = () => setShowModal(false);
  const handelClearParameter = () => {
    setSearchOptions({
      tagId: null,
    });
    resetFindOptions();
  };

  const onChangeFieldValue = (value: object) => {
    setSearchOptions({ ...searchOptions, ...value });
  };
  const onClickFind = (findOptions: any) => {
    handleFind(findOptions);
    handleModalClose();
  };

  return (
    <>
      <div className="float-end">
        <Button
          variant="primary"
          className="ml-1 mb-3"
          onClick={handleModalOpen}
        >
          Find Options
        </Button>
        <Modal show={showModal} onHide={handleModalClose}>
          <Modal.Header closeButton>
            <Modal.Title>Find Tags</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Button
              className="mb-3"
              variant="secondary"
              onClick={() => handelClearParameter()}
            >
              Clear Parameters
            </Button>
            <Form>
              <Form.Group className="mb-3" controlId="findTags">
                <Form.Label>Tags</Form.Label>
                <Select
                  options={tagListForDropdown}
                  labelField="tagName"
                  valueField="tagId"
                  searchable
                  searchBy={"tagName"}
                  onChange={(values) =>
                    onChangeFieldValue({ tagId: values[0]?.tagId })
                  }
                  values={[]}
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleModalClose}>
              Close
            </Button>
            <Button
              variant="primary"
              onClick={() => onClickFind(searchOptions)}
            >
              Find
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>#</th>
            <th>Website Tags</th>
          </tr>
        </thead>
        <tbody>
          {tagsList.map((tag: AppTagDetail, index: number) => (
            <tr key={tag.tagId}>
              <td>{tag.tagId}</td>
              <td>{tag.tagName}</td>
              <td>
                <Button
                  variant="danger"
                  onClick={() => handelDelete(tag.appTagId, tag.tagId)}
                >
                  Delete
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      {tagsList.length > 0 ? (
        <>
          <PaginationWithControls
            pageIndex={pageIndex}
            pageSize={pageSize}
            listCount={totalItemCount}
            onChangePageIndex={onChangePageIndex}
            onChangePageSize={onChangePageSize}
          />
        </>
      ) : (
        <p className="text-center py-3">No results found</p>
      )}
    </>
  );
};

export default ListTagDetail;
